var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip_wrap"},[_c('span',{staticClass:"tip_info"},[_vm._v("*")]),_c('div',{staticClass:"tip_item"},[_vm._t("item")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }